import axios from "axios";

export const songToSermon = async (query) => {
  const url =
    axios.getUri({ url: "/api/songToSermon", params: query }) ||
    `/api/songToSermon`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
